import { BORROW, DEPOSIT, STAKING } from "@/utils/constants"
import {
  PopupBorrowRepayState,
  PopupClaimStakingState,
  PopupDevelopingState,
  PopupModalRewardState,
  PopupStakeUnstakeState,
  PopupStopUnstakingState,
  PopupSupplyWithdrawState,
} from "@/utils/dataTypes"
import { atom } from "jotai"

export const appSupplyUSDSNoticePopupState = atom<boolean>(false)

export const appSupplyWithdrawPopupState = atom<PopupSupplyWithdrawState>({
  isOpen: false,
  type: DEPOSIT,
})

export const appBorrowRepayPopupState = atom<PopupBorrowRepayState>({
  isOpen: false,
  type: BORROW,
})

export const appStakeUnstakePopupState = atom<PopupStakeUnstakeState>({
  isOpen: true,
  type: STAKING,
})

export const appClaimStakingPopupState = atom<PopupClaimStakingState>({
  isOpen: false,
})

export const appStopUnstakingPopupState = atom<PopupStopUnstakingState>({
  isOpen: false,
})

export const appDevelopingModalPopupState = atom<PopupDevelopingState>({
  isOpen: false,
})

export const appNFTRewardModalRewardState = atom<PopupModalRewardState>({
  isOpen: false,
})
